import React, { useEffect } from 'react'
import {BrowserRouter as Router,Route,Routes} from "react-router-dom"
import HomePage from './components/homePage/HomePage'
import Header from './components/layout/header/Header'
import Courses from './components/courses/Courses'
import Footer from './components/layout/footer/Footer'
import Login from './components/Auth/login/Login'
import Register from './components/Auth/register/Register'
import ForgotPassword from './components/Auth/login/ForgotPassword'
import ResetPassword from './components/Auth/login/ResetPassword'
import ContactPage from './components/Contact/ContactPage'
import RequestPage from './components/Request/RequestPage'
import AboutPage from './components/About/AboutPage'
import SubscribePage from './components/Payments/SubscribePage'
import NotFound from "./components/layout/NotFound/NotFound"
import PaymentSuccess from './components/Payments/PaymentSuccess'
import PaymentFail from './components/Payments/PaymentFail'
import CoursePage from './components/CoursePage/CoursePage'
import ProfilePage from './components/Profile/ProfilePage'
import ChangePassword from './components/Profile/ChangePassword'
import UpdateProfile from './components/Profile/UpdateProfile'
import Dashboard from './components/Admin/Dashboard/Dashboard'
import CreateCourse from './components/Admin/CreateCourse/CreateCourse'
import Users from './components/Admin/Users/Users'
import AdminCourses from './components/Admin/AdminCourses/AdminCourses'
import { useDispatch, useSelector } from 'react-redux'
import toast,{Toaster} from "react-hot-toast"
import { loadUser } from './redux/actions/user'
import {ProtectedRoute} from "protected-route-react"
import Loader from './components/layout/Loader/Loader'


const App = () => {
  window.addEventListener('contextmenu',(e)=>{
      e.preventDefault();
  })
  const {isAuth,user,message,error,loading} = useSelector(state=>state.user);
  // console.log(user);
  const dispatch = useDispatch();
  useEffect(() => {
    if(error){
      toast.error(error);
      dispatch({type:'clearError'})
    }
    if(message){
      toast.success(message);
      dispatch({type:'clearMessage'})
    }
  }, [dispatch,error,message]);

  useEffect(() => {
    dispatch(loadUser())
  }, [dispatch])
  
  
  return (
    <Router>
      {
        loading ? (<Loader/>) : (
          <>
          <Header isAuth={isAuth} user={user}/>
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/courses" element={<Courses/>}/>
        <Route path="/contact" element={<ContactPage/>}/>
        <Route path="/login" element={
          // <ProtectedRoute isAuth={!isAuth} redirect="/">
          <Login/>
        // 
        }/>
        <Route path="/register" element={
        // <ProtectedRoute isAuth={!isAuth} redirect="/">
          <Register/>
        // </ProtectedRoute>
      } />
        <Route path="/request" element={<RequestPage/>}/>
        <Route path="/about" element={<AboutPage/>}/>
        <Route path="/subscribe" element={<SubscribePage/>}/>
        <Route path="/forgotpassword" element={<ForgotPassword/>}/>
        <Route path="/resetpassword/:token" element={<ResetPassword/>}/>
        <Route path="*" element={<NotFound/>}/>
        <Route path="/course/:id" element={<CoursePage/>}/>
        <Route path="/paymentsuccess" element={<PaymentSuccess/>}/>
        <Route path="/paymentfail" element={<PaymentFail/>}/>
        {/* <Route path="/profile" element={
        <ProtectedRoute isAuth={isAuth}>
          <ProfilePage/>
          </ProtectedRoute> 
      }/> */}
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/changepassword" element={<ChangePassword/>}/>
        <Route path="/updateprofile" element={<UpdateProfile/>}/>
        <Route path="/admin/dashboard" element={
          <Dashboard/>
        }/>
        <Route path="/admin/createcourse" element={<CreateCourse/>}/>
        <Route path="/admin/users" element={<Users/>}/>
        <Route path="/admin/courses" element={<AdminCourses/>}/>
      </Routes>
      <Footer/>
      <Toaster/>
      </>
        )
      }
    </Router>
  )
}

export default App